import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@material-ui/core";
import { Controller } from "react-hook-form";

export function RadioButton({
    label, 
    readonly, 
    control
}: {
    label: string,
    readonly: boolean,
    control: any,
}) {
    
    return (
        <Grid item xs={6} md={6}>
            <FormControl required>
                <FormLabel id="demo-row-radio-buttons-group-label" className="dark:text-white">{label}</FormLabel>
                <Controller
                name="ruleType"
                control={control}
                defaultValue="RETAIL_CHAIN"
                render={({ field }) => (
                <RadioGroup {...field} row>
                    <FormControlLabel disabled={readonly} value={"RETAIL_CHAIN"} control={<Radio />} label="Bandeira" className="dark:text-white"/>
                    <FormControlLabel disabled value="disabled" control={<Radio />} label="Distribuidor" className="dark:text-white"/>
                </RadioGroup>
                )}
            />
            </FormControl>
        </Grid>
    )
}